export class ConnectionError extends TypeError {
  constructor(readonly kind: "network" | "timeout", readonly uncertain: boolean, cause: unknown) {
    super(uncertain
      ? "Connection interrupted. The request may have reached the server; check its result before trying again."
      : kind === "timeout"
        ? "The server did not respond in time. Check your connection and retry."
        : "Could not reach the server. Check your connection and retry.", { cause })
    this.name = "ConnectionError"
  }
}

export function connectionError(error: unknown, method = "GET", signal?: AbortSignal | null) {
  if (error instanceof ConnectionError) return error
  const timeout = signal?.reason?.name === "TimeoutError" || (error instanceof Error && error.name === "TimeoutError")
  if (signal?.aborted && !timeout) return error
  if (!timeout && !(error instanceof TypeError)) return error
  return new ConnectionError(timeout ? "timeout" : "network", !["GET", "HEAD"].includes(method.toUpperCase()), error)
}
